(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["segment-coupon-cards"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__segmentCouponCopyInitialized) return;
    window.__segmentCouponCopyInitialized = true;

    const copyText = async (text) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = text;
      tempTextArea.setAttribute('readonly', '');
      tempTextArea.style.position = 'absolute';
      tempTextArea.style.left = '-9999px';
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
    };

    document.addEventListener('click', async (event) => {
      const copyButton = event.target.closest('[data-segment-coupon-copy]');
      if (!copyButton) return;

      const copyCode = copyButton.getAttribute('data-segment-coupon-copy');
      if (!copyCode) return;

      try {
        await copyText(copyCode);
        const defaultLabel = copyButton.getAttribute('data-copy-default-label');
        const successLabel = copyButton.getAttribute('data-copy-success-label');

        if (successLabel) {
          copyButton.textContent = successLabel;
          copyButton.classList.add('is-copied');
          window.setTimeout(() => {
            copyButton.textContent = defaultLabel || successLabel;
            copyButton.classList.remove('is-copied');
          }, 2000);
        }
      } catch (error) {
        console.error('Failed to copy coupon code', error);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
